import React from "react";
import Input from "../../../../../../../components/Input";
import useEletronicInventoryStore from "../../store/useStore";

export default function RowTreeAndFour() {
  const { defaultValues } = useEletronicInventoryStore();
  const { saveDataOfField } = useEletronicInventoryStore();

  return (
    <>
      <div className="box-row">
        <Input
          name="description"
          label="Descrição"
          placeholder="Digite a Descrição"
          value={defaultValues?.description}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="manufacturer"
          label="Fabricante"
          placeholder="Digite o nome do fabricante"
          value={defaultValues?.manufacturer}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
      <div className="box-row">
        <Input
          name="model"
          label="Modelo do Produto"
          placeholder="Digite o modelo do produto"
          value={defaultValues?.model}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="processor"
          label={`Processador do item`}
          placeholder="Digite o nome do processador"
          value={defaultValues?.processor}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
    </>
  );
}
